module.exports = {"410185001":"嵩阳街道","410185002":"少林街道","410185003":"中岳街道","410185004":"卢店街道","410185100":"大金店镇","410185101":"颍阳镇","410185103":"告成镇","410185105":"大冶镇","410185106":"宣化镇","410185107":"徐庄镇","410185108":"东华镇","410185109":"唐庄镇","410185202":"白坪乡","410185203":"君召乡","410185204":"石道乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410185.json
// module id = 1646
// module chunks = 0